define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"dojo/_base/window",
	"csi/html",
	"csi/sessionConstants",
	"csi/types",
	"csi/widget/CommentDialog",
	"csi/xml",
	"dojo/text!csi/widget/CommentDialog.html"
], function(declare, lang, win, html, sessionConstants, types, CommentDialog, xml, template) {

	let _div;

	function _getRichRefNode() {
		return _div || html.create("div", {
			"class": html.CSS_RICH_TEXT,
			style: "position: absolute; left: -1000px; width: 1px;"
		}, win.body());
	}

	return declare(null, {
		bRichRefNode: false,
		dialogTemplate: template,
		commentValues: null,
		csiDialog: null,

		edit: function(/*String*/title, /*Object?*/value) {
			value = value || {text: ""};
			value.text = value.text ? html.sanitize(value.text) : "";

			this.csiDialog = new CommentDialog({
				csiRefNode: this.bRichRefNode ? _getRichRefNode() : this.m_element,
				formTemplate: this.dialogTemplate,
				title: title,
				value,
				onSave: lang.hitch(this, this._onSave),
				onCancel: lang.hitch(this, this._onCancel)
			});
			this.csiDialog.startup();
			this.csiDialog.show();
		},

		preProcess: function() {
			if (commentValues.subject) {
				commentValues.subject = commentValues.subject.trim();
			}
			this.inherited(arguments);
		},

		_onSave: function(/*Object*/value) {
			if (value.subject) {
				value.subject = value.subject.trim();
				if (value.subject == "") {
					return false;
				}
			}

			this.commentValues = value;
			this.preProcessContinue();
			this.csiDialog.hide();
		},

		_onCancel: function() {
			this.postProcess();
		},

		toWriterComment: function() {
			var cn = this.m_writer.changeNode(this.m_urlNode)
				.changeAttribute("Author", xml.ATTR_REF, sessionConstants.userUrl)
				.changeAttribute("Comment", xml.ATTR_STRING, this.commentValues.text);

			if (this.commentValues.subject) {
				cn.changeAttribute(xml.ATTR_NAME, xml.ATTR_STRING, this.commentValues.subject);
			}
		}
	});
});